import {
	animation,
	trigger,
	animate,
	transition,
	state,
	style,
	query,
	group,
	animateChild,
	stagger
} from '@angular/animations';

const duration = '1s';


export const tabsAnimation = trigger('tabsAnimation', [

	transition('false => 2', [

		group([
		
			query('.facets', [style({height: '0', position: 'relative'})]),
			query(
				'.facets',
				[style({height: '0', position: 'relative'}), animate(duration + ' ease-in-out', style({height: '*', position: 'relative'}))]
			),
			query('.sort', [style({height: '*', position: 'absolute'})]),
			query(
				'.sort',
				[style({height: '*', position: 'absolute'}), animate(duration + ' ease-in-out', style({height: '0', position: 'absolute'}))]
			)
		]),
		query('@expandFacetAnimation', [
        animateChild()
    ])/*,
		query('@expandSortAnimation', [
        animateChild()
    ])*/

	]),

	transition('false => 1', [

		group([
		
			query('.facets', [style({height: '*', position: 'absolute'})]),
			query(
				'.facets',
				[style({height: '*', position: 'absolute'}), animate(duration + ' ease-in-out', style({height: '0', position: 'absolute'}))]
			),
			query('.sort', [style({height: '0', position: 'relative'})]),
			query(
				'.sort',
				[style({height: '0', position: 'relative'}), animate(duration + ' ease-in-out', style({height: '*', position: 'relative'}))]
			)
		])/*,
		query('@expandFacetAnimation', [
        animateChild()
    ])*/,
		query('@expandSortAnimation', [
        animateChild()
    ])

	])
]);


export const expandFacetAnimation = trigger('expandFacetAnimation', [

	
	state('*', style({ display: 'block' })),
	state('false', style({ display: 'none' })),
	transition('false => *', [animate('0s', style({display: 'block'}))]),
	transition('* => false', [animate('0s 0.8s', style({display: 'block'}))])


	
]);

export const expandSortAnimation = trigger('expandSortAnimation', [

	//state('false', style({ height: '0', position: 'absolute' })),
	//state('1', style({ height: '*', position: 'relative' }))

	
]);



